import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { Section } from '@/features/new-landing-page/components/section';
import { StrapiTextual } from '@/features/strapi/components/textual';
import { ReviewsContent } from '@/features/new-landing-page/pages/homepage-content';
import { VSpace } from '@/components/spacing';
import { StrapiReviewCard } from '@/features/strapi/components/review-card';
import { Marquee } from '@/features/new-landing-page/components/marquee';

export function ReviewsSection() {
  return (
    <Section>
      <VSpace value={4} />
      <StrapiTextual {...ReviewsContent.title} />

      <StarsRatingIcon />
      <VSpace value={0.1} />
      <Marquee gap="4rem" duration={220}>
        {ReviewsContent.reviews
          ?.filter((review) => !review.author)
          ?.map((review) => (
            <StrapiReviewCard key={review.store} {...review} />
          ))}
      </Marquee>
      <VSpace value={8} />
    </Section>
  );
}

function StarsRatingIcon() {
  return (
    <Wrapper>
      <StaticImage
        className="only-desktop"
        src="../../../assets/landing/stars-rating-row-white.png"
        alt="Shopify Logo"
        placeholder="none"
        loading="eager"
        quality={100}
        width={110}
        objectFit="contain"
      />
      <StaticImage
        className="only-mobile"
        src="../../../assets/landing/stars-rating-row-white.png"
        alt="Shopify Logo"
        placeholder="none"
        loading="eager"
        width={80}
        objectFit="contain"
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  .gatsby-image-wrapper {
    filter: invert(1);
  }
`;
